import React from 'react';

function PrivacySEO() {
  return <meta name="description" content="Privacy policy Closure" />;
}

export default PrivacySEO;
